import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import TeamLogo from './TeamLogo'
import useSportEntities from '@hooks/useSportEntities'
import Blink from '@components/Blink'

interface TeamCellProps {
  teamId: string
  teamLogoSrc: string
  teamName: string
  hasInvertedColors: boolean
}

type StyledTeamNameProps = Pick<TeamCellProps, 'hasInvertedColors'>

const StyledTeamCell = styled.div`
  ${({
    theme: {
      spacing: { spacing8 },
    },
  }) => css`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-auto-flow: column;
    align-items: center;
    grid-column-gap: ${spacing8};
    width: 100%;
    min-height: 48px;
  `}
`

const StyledTeamName = styled.div<StyledTeamNameProps>`
  ${({
    theme: {
      colors: { textDefault, staticNeutral100 },
      typography: {
        headings: {
          xxsmall: { bundledCSS: xxsmallHeadingCSS },
        },
      },
      utils: { ellipsis },
    },
    hasInvertedColors,
  }) => {
    return css`
      ${xxsmallHeadingCSS};
      color: ${hasInvertedColors ? staticNeutral100 : textDefault};
      ${ellipsis('100%', 2)};
    `
  }}
`
const StyledClickableTeamWrapper = styled(Blink)`
  ${({
    theme: {
      spacing: { spacing8 },
    },
  }) => {
    return css`
      text-decoration: none;
      display: flex;
      align-items: center;
      gap: ${spacing8};
    `
  }}
`

const TeamCell: FunctionComponent<TeamCellProps> = ({
  teamId,
  teamLogoSrc,
  teamName,
  hasInvertedColors,
}) => {
  const { getSportEntityBySportradarId } = useSportEntities()
  const entityLink = getSportEntityBySportradarId(teamId)?.link?.href || ''
  return (
    <StyledTeamCell>
      {entityLink ? (
        <StyledClickableTeamWrapper href={entityLink}>
          <TeamLogo url={teamLogoSrc} name={teamName} />
          <StyledTeamName hasInvertedColors={hasInvertedColors}>
            {teamName}
          </StyledTeamName>
        </StyledClickableTeamWrapper>
      ) : (
        <>
          <TeamLogo url={teamLogoSrc} name={teamName} />
          <StyledTeamName hasInvertedColors={hasInvertedColors}>
            {teamName}
          </StyledTeamName>
        </>
      )}
    </StyledTeamCell>
  )
}

export default TeamCell
